import CircularProgress from "@mui/material/CircularProgress";
import './index.scss';

const Spinner = ({ type, white = false }) => {
  let size = 65;
  let thickness = 1.7;

  if (type === 'small') {
    size = 40;
    thickness = 2.5;
  } else if (type === 'smallest') {
    size = 23;
    thickness = 3;
  }

  return <CircularProgress
    size={size}
    thickness={thickness}
    className={white ? 'white-spinner' : ''}
  />
};

export default Spinner;

